import { useFpB2bCouponService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-coupon-service'
import { type CartFormValues } from '@cart-services/zod-schema/cartFormSchema'
import { RegularGiveawayProgressBar } from '@cart-ui/RegularGiveawayProgressBar/RegularGiveawayProgressBar'
import { AppliedStatus } from '@hooks-api/types/dataModel/coupon'
import { VStack } from '@pets-ui/VStack/VStack'
import { useEffect, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { useStmCart } from '../../CartProvider'
import { CartCard } from '../CartCard'
import { CartCardBody } from '../CartCardBody'
import { CartCardHeader } from '../CartCardHeader'
import { RegularGiveawaySelectController } from './RegularGiveawaySelectController'
import { Skeletons } from './Skeletons'

export const CartRegularGiveawayTips = () => {
  const { projectCode, campaignId, countryCode, campaignCode, deliveryClass, platform } = useStmCart()
  const { clearErrors } = useFormContext<CartFormValues>()
  const { regularGiveaways, getRegularGiveawayProgress, removeSelectedRegularGiveaways } = useFpB2bCouponService(
    campaignId,
    projectCode,
    countryCode,
    campaignCode,
    platform,
  )
  const { percentage, totalCriterions, currentCriterions } = useMemo(() => getRegularGiveawayProgress(regularGiveaways), [getRegularGiveawayProgress, regularGiveaways])
  const filteredRegularGiveaways = useMemo(() => deliveryClass ? regularGiveaways?.filter(regularGiveaway => regularGiveaway.productDeliveryClasses?.includes(deliveryClass)) : regularGiveaways, [regularGiveaways, deliveryClass])
  const regularGiveawayList = useMemo(() => regularGiveaways.flatMap(regularGiveaway => regularGiveaway.criterions), [regularGiveaways])

  /**
   * 當原本已選擇的滿額禮不符合資格時，需清除不符合資格之滿額禮
   */
  useEffect(() => {
    const filterUnappliedSelectedRegularGiveaways = filteredRegularGiveaways?.flatMap(regularGiveaway =>
      regularGiveaway.criterions
        .filter(criterion => criterion.applied_status !== AppliedStatus.APPLIED)
        .map(criterion => criterion.id),
    ) ?? []
    if (filterUnappliedSelectedRegularGiveaways.length > 0) {
      removeSelectedRegularGiveaways(filterUnappliedSelectedRegularGiveaways)
      clearErrors('regularGiveaways')
    }
  }, [clearErrors, filteredRegularGiveaways, removeSelectedRegularGiveaways])

  if (!regularGiveaways) return <Skeletons title="滿額禮" />
  if (regularGiveaways.length === 0) return null

  return (
    <CartCard>
      <CartCardHeader title="滿額禮" />
      <CartCardBody>
        <VStack gap={2}>
          <RegularGiveawayProgressBar
            total={totalCriterions}
            current={currentCriterions}
            value={percentage}
          />
          {regularGiveawayList.map((criterion, index) => <RegularGiveawaySelectController key={criterion.id} index={index} criterion={criterion} />)}
        </VStack>
      </CartCardBody>
    </CartCard>
  )
}
